import { ChangeDetectorRef, Component, Inject, OnInit, Optional, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FormBuilder } from '@angular/forms';
import { LoadingService } from 'src/app/services/loading.service';
import { FileService } from 'src/app/services/api/file.service';

@Component({
  selector: 'app-dialog-proveedor',
  templateUrl: './dialog-proveedor.component.html',
  styleUrls: ['./dialog-proveedor.component.css']
})
export class DialogProveedorComponent implements OnInit {

  DataSource = new MatTableDataSource<any>([]);
  DisplayedColumns: string[] = ['numRUC', 'nombre', 'codigo', 'tipoProveedor', 'actions'];
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;

  arrayTipoProveedor: any = ['ALOJAMIENTO', 'GUIA','TRANSPORTE','PERSONALDECAMPO','OPERADOR','RESTAURANTE','ENTRADA','EXPLORANDES'];
  selectTipoProveedor: string | null = null;
  dataTemp:any = [];
  currentList:any = [];

  loading:boolean=true;

  constructor(private fb: FormBuilder, public dialogRef: MatDialogRef<DialogProveedorComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any,private fileService: FileService, private changeDetectorRefs: ChangeDetectorRef,
    private router: Router, public loadingService: LoadingService) { }

  ngOnInit(): void {
    this.loadProviders();
  }

  loadProviders(){
    this.fileService.getAllProvidersSourcing().subscribe( data => {
      this.DataSource = new MatTableDataSource(data.getAllProvider);
      this.dataTemp = data.getAllProvider
      this.DataSource.paginator = this.paginator;
      this.DataSource.sort = this.sort;
      this.changeDetectorRefs.detectChanges();
      console.log("providers: ",data.getAllProvider);
      this.loading=false;
    });
  }

  goBack(ele: any){
    this.dialogRef.close(ele);
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;

    this.DataSource.data.forEach((element: { [x: string]: string; }) => {
      for (const key in element) {
        if (!element[key] || element[key] === null) {
          element[key] = '';
        }
      }
    });

    this.DataSource.filter = filterValue.trim().toLowerCase();
  }

  getCodigo(x: string): String{
    var newX = x.split("-");
    return newX[0]+'-'+newX[2]
  }

  applyFilterSelect() {

    if (this.selectTipoProveedor) {
      console.log('tipoProveedor', this.selectTipoProveedor);
      this.currentList = this.dataTemp.filter((item: any) => item.tipoProveedor === this.selectTipoProveedor);
      this.DataSource.data = this.currentList

    }else {
      this.DataSource.data = this.dataTemp
    }


  }

}
